import { render, staticRenderFns } from "./ProceedButton.vue?vue&type=template&id=6d22e4a0"
import script from "./ProceedButton.vue?vue&type=script&lang=js"
export * from "./ProceedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports